import AllContainers from "barcelo-components/containers";
import AdvComponents from "barcelo-components/adv";
import ComparatorsComponents from "barcelo-components/comparators";
import StructureComponents from "barcelo-components/structure";
import HotelComponents from "barcelo-components/hotel";
import IAComponents from "barcelo-components/ia";
import FormsComponents from "barcelo-components/forms";
import GenericComponents from "barcelo-components/generic";
import ListingComponents from "barcelo-components/listing";
import MenuComponents from "barcelo-components/menu";
import VariousComponents from "barcelo-components/various";
import TeasersComponents from "barcelo-components/teasers";
import FaqComponents from "barcelo-components/faq";
import MyBarceloComponents from "barcelo-components/mybarcelo";
import TargetComponents from "barcelo-components/adobeTarget";
import AllBrhComposition from "../../components/brh/composition";
import AllBrhBase from "brh-components/base";

const { submenuContainer, container, swiper, accordion, tabsdropdown, tabMenu, launchersContainer, xfContainer, marketTargeting, languageTargeting } = AllContainers;
const { ribbon, languageRibbon, translationEnabledLanguageDialog } = AdvComponents;
const { comparatorsInitializer, cardHotelCompactMeeting } = ComparatorsComponents;
const {
  modalService,
  modalMeetingRoom,
  stickyService,
  brands,
  megaMenu,
  subHeader,
  asideMenu,
  language,
  phoneCC,
  header,
  heroslider,
  hotelMeetingRooms,
  hotelRoyal,
  calendar,
  destination,
  searchHotel,
  discount,
  highlightsGallery,
  awardsSwiper,
  rooms,
  fastbooking,
  fastbookingLite,
  customModal,
  headerDetail,
  campaignGenericComponentGroup,
  localeConfigurationForm,
  footer,
  headHotelInfo,
  uspCampaign,
  mybAuthUser,
  breadcrumb,
  hightlightServiceBanner,
  hotelRoyalLevel,
} = StructureComponents;
const { cardHotel, meetingTable, hotelHorizontalCompact, hotelRelated, weather, dorintHotelCards, hotelHighlights, hotelListCarousel, tripAdvisor, hotelReturn, hotelMapCard } = HotelComponents;
const { IAList } = IAComponents;
const { loggedUpdateForm, dataCollectDestinationForm, serviceContactForm, experiencesForm, deleteMyBarceloForm, newsletterForm } = FormsComponents;
const { cta, socialSharing, filePicker, rp1Offer, homeCampaign, icon, progressBar, tooltip, rteTooltip, cmpTabs, hotelPageAnalytics, panorama, flipcard, label, textImage } = GenericComponents;
const { feedEntries, cardHotelList, collectionsListing, offerDestination, promoList, swiperCollectionList, campaignList, uspCampaignHotelList, valueAdsList, destinationsList, offer, collectionList } = ListingComponents;
const { stripeMenu, vMenu } = MenuComponents;
const {
  languageDialog,
  currencyDialog,
  profilingWizardItem,
  profWizard,
  opinion,
  phoneContact,
  socialRoom,
  interactiveMap,
  customChrono,
  countdown,
  carouselExtras,
  uspCampaignBanner,
  meetingForm,
  meetComparatorCard,
  uspNightsDetails,
  moduleInfoCall,
  premiumBanner,
  premiumServicesList,
  royalBanner,
  appDownloadBanner,
  servicesListEditorial,
  regenImage,
  centralImage,
  campaignChrono,
  sectionHeadings,
  cardHotelHorizontal,
  cardHotelDates,
  burger,
  scrollUp,
  promoBannerCollect,
  campaignBanner,
  dynamicWarnings,
} = VariousComponents;
const { carousel, coupon, servicesCarousel, card, cardHotelServices, fourNewsCarousel, launcher, menuCards, experienceCards, gallerySummary, collectionCarouselHotels, collectionCarouselList, advantagesCards, infoServicePage, teaserHotelCard } =
  TeasersComponents;
const { faq, widgetFaq, dynamicFaqs } = FaqComponents;
const {
  mybLoyaltyTargeting,
  mybTriggerBanner,
  mybLoyaltyHero,
  mybLoyaltyInfo,
  mybProfile,
  mybMenu,
  mybContent,
  mybProfileStatus,
  mybReservations,
  mybHero,
  mybBannerAnimated,
  mybDetails,
  mybFeatures2,
  mybVideo,
  mybBenefit,
  mybBookingHistory,
  mybCurrentBooking,
  mybPreferences,
  mybEditProfileV2,
  mybOpinion,
  mybEditProfile,
  mybBanner,
  favoriteHotel,
  priceTracking,
  mybFavoriteHotels,
  mybPriceTracking,
} = MyBarceloComponents;
const { cardHotelHomeTarget, cardHotelTarget } = TargetComponents;
const { brhBannerQuote } = AllBrhComposition;
const { brhMultimedia } = AllBrhBase;

const isReservationBarcelo = window.location.hostname === "reservation.barcelo.com";
const isMobileViewport = () => typeof window.matchMedia === "function" && window.matchMedia("(max-width: 768px)").matches;

const preloadFastbookingCssOnMobile = () => {
  if (!isMobileViewport() || !document.querySelector(".c-fastbooking") || typeof window.bcl?.u?.loadStyleSheet !== "function") {
    return;
  }

  const popoverStylesReady = window.bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-popover.css");
  window.bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-fastbooking.css", ".c-fastbooking.dynamicLoading", false, false, null, popoverStylesReady);
};

const allComponents = {
  modalService,
  modalMeetingRoom,
  stickyService,
  tooltip,
  rteTooltip,
  header,
  heroslider,
  ribbon,
  swiper,
  headHotelInfo,
  campaignList,
  valueAdsList,
  container,
  destination,
  searchHotel,
  calendar,
  discount,
  rooms,
  cta,
  icon,
  campaignGenericComponentGroup,
  vMenu,
  megaMenu,
  subHeader,
  asideMenu,
  headerDetail,
  stripeMenu,
  phoneCC,
  footer,
  fastbooking,
  fastbookingLite,
  accordion,
  tabsdropdown,
  languageDialog,
  language,
  languageRibbon,
  translationEnabledLanguageDialog,
  languageTargeting,
  brands,
  hotelMeetingRooms,
  hotelRoyal,
  awardsSwiper,
  highlightsGallery,
  customModal,
  localeConfigurationForm,
  hotelRelated,
  hotelReturn,
  weather,
  rp1Offer,
  socialSharing,
  feedEntries,
  cardHotelList,
  collectionsListing,
  offerDestination,
  promoList,
  swiperCollectionList,
  currencyDialog,
  profilingWizardItem,
  profWizard,
  opinion,
  phoneContact,
  socialRoom,
  interactiveMap,
  customChrono,
  countdown,
  carouselExtras,
  carousel,
  coupon,
  servicesCarousel,
  card,
  cardHotelServices,
  fourNewsCarousel,
  launcher,
  faq,
  dynamicFaqs,
  IAList,
  comparatorsInitializer,
  moduleInfoCall,
  uspNightsDetails,
  xfContainer,
  marketTargeting,
  progressBar,
  cmpTabs,
  panorama,
  flipcard,
  breadcrumb,
  premiumBanner,
  premiumServicesList,
  royalBanner,
  appDownloadBanner,
  servicesListEditorial,
  loggedUpdateForm,
  dataCollectDestinationForm,
  serviceContactForm,
  experiencesForm,
  deleteMyBarceloForm,
  newsletterForm,
  regenImage,
  centralImage,
  campaignChrono,
  destinationsList,
  widgetFaq,
  mybOpinion,
  mybEditProfile,
  mybTriggerBanner,
  favoriteHotel,
  priceTracking,
  scrollUp,
  dorintHotelCards,
  hotelHighlights,
  menuCards,
  mybLoyaltyHero,
  mybLoyaltyInfo,
  experienceCards,
  gallerySummary,
  collectionCarouselHotels,
  collectionCarouselList,
  launchersContainer,
  mybBanner,
  mybLoyaltyTargeting,
  mybProfile,
  mybMenu,
  mybContent,
  mybProfileStatus,
  mybReservations,
  mybHero,
  mybBannerAnimated,
  mybDetails,
  mybFeatures2,
  mybVideo,
  mybBenefit,
  mybBookingHistory,
  mybCurrentBooking,
  mybPreferences,
  mybEditProfileV2,
  mybFavoriteHotels,
  mybPriceTracking,
  filePicker,
  tabMenu,
  uspCampaignBanner,
  uspCampaign,
  mybAuthUser,
  uspCampaignHotelList,
  homeCampaign,
  meetingForm,
  meetComparatorCard,
  hotelListCarousel,
  cardHotelHomeTarget,
  cardHotelTarget,
  offer,
  tripAdvisor,
  sectionHeadings,
  cardHotelHorizontal,
  cardHotelDates,
  burger,
  submenuContainer,
  cardHotelCompactMeeting,
  hightlightServiceBanner,
  hotelRoyalLevel,
  cardHotel,
  meetingTable,
  hotelHorizontalCompact,
  label,
  textImage,
  collectionList,
  advantagesCards,
  infoServicePage,
  teaserHotelCard,
  hotelMapCard,
  hotelPageAnalytics,
  promoBannerCollect,
  campaignBanner,
  dynamicWarnings,
  brhBannerQuote,
  brhMultimedia,
};

if (isReservationBarcelo) {
  const componentsToExclude = ["carouselExtras", "footer", "fastbooking", "feedEntries", "brands", "destination", "header"];
  componentsToExclude.forEach((component) => {
    delete allComponents[component];
  });
}

preloadFastbookingCssOnMobile();

export default allComponents;
